import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
    'inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
    {
        variants: {
            variant: {
                default: 'border-transparent bg-secondary text-secondary-foreground',
                outline: 'border-border text-foreground',
                positive: 'border-transparent bg-positive text-positive-foreground',
                warning: 'border-transparent bg-warning text-warning-foreground',
                inProgress: 'border-transparent bg-in-progress text-in-progress-foreground',
                destructive: 'border-transparent bg-destructive text-destructive-foreground',
                muted: 'border-transparent bg-muted text-muted-foreground',
            },
        },
        defaultVariants: { variant: 'default' },
    },
)

export interface BadgeProps
    extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge }
